import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=30224902"
import script from "./GroupTable.vue?vue&type=script&lang=js"
export * from "./GroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports